import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { getPartnerCampaign, getPartnerCampaignAnalytics } from "@/lib/api";

export default function PartnerCampaignPage() {
  const { slug } = useParams();
  const [campaign, setCampaign] = useState(null);
  const [analytics, setAnalytics] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const c = await getPartnerCampaign(slug);
        if (!alive) return;
        setCampaign(c);
        try {
          const a = await getPartnerCampaignAnalytics(slug);
          if (alive) setAnalytics(a);
        } catch {
          if (alive) setAnalytics(null);
        }
        setError(null);
      } catch (err) {
        if (!alive) return;
        setError(err?.response?.data?.detail || "Campaign unavailable");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [slug]);

  const budget = analytics?.budget;

  return (
    <div className="min-h-screen grain">
      <Navbar category="tokens" />
      <main className="mx-auto max-w-3xl px-4 py-8">
        <Link to="/battles" className="text-xs text-zinc-500 hover:text-white">← Battles</Link>
        <p className="mt-4 text-[10px] uppercase tracking-[0.25em] text-zinc-600">Partner campaign</p>
        <h1 className="mt-2 font-display text-3xl font-black tracking-tight">
          {campaign?.name || slug}
        </h1>
        {campaign && (
          <p className="mt-2 text-sm text-zinc-400" data-testid="partner-campaign-status">
            {campaign.status} · {campaign.starts_at} → {campaign.ends_at}
          </p>
        )}
        {loading && <div className="mt-8 text-sm text-zinc-500">Loading…</div>}
        {error && <div className="mt-8 text-sm text-zinc-400" data-testid="partner-campaign-error">{error}</div>}
        {analytics && (
          <div className="mt-8 space-y-4" data-testid="partner-campaign-analytics">
            <div className="grid gap-3 sm:grid-cols-3">
              <div className="rounded-xl border border-white/10 px-4 py-3">
                <div className="text-[10px] uppercase tracking-wider text-zinc-600">Organic Backing</div>
                <div className="mt-1 font-mono text-lg font-bold text-gold">
                  ${Number(analytics.organic_verified_backing || 0).toLocaleString()}
                </div>
              </div>
              <div className="rounded-xl border border-white/10 px-4 py-3">
                <div className="text-[10px] uppercase tracking-wider text-zinc-600">CLR settled</div>
                <div className="mt-1 font-mono text-lg font-bold">
                  {analytics.community_leverage_ratio_settled != null
                    ? `${analytics.community_leverage_ratio_settled}x`
                    : "—"}
                </div>
              </div>
              <div className="rounded-xl border border-white/10 px-4 py-3">
                <div className="text-[10px] uppercase tracking-wider text-zinc-600">Budget remaining</div>
                <div className="mt-1 font-mono text-lg font-bold">{budget?.remaining ?? "—"}</div>
              </div>
            </div>
            <p className="text-xs text-zinc-600">{analytics.disclaimer}
            Funding uses exact chain + token contract + destination — never ticker alone. Partners cannot self-verify funding or publish Merkle roots.</p>
          </div>
        )}
      </main>
    </div>
  );
}
